// extracted by mini-css-extract-plugin
export default {"button-container":"spousal-profile-module__button-container--oe4","buttonContainer":"spousal-profile-module__button-container--oe4"};